<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content" style="padding-bottom:0;">
        <el-form label-position="left" style="display: flex">
          <el-form-item :label="$t('CargoMsg.SourceCompany')" label-width="80px" style="width: 400px">
            <cargo-advance-select
              no="tenantId"
              :select-type="TYPE_NAMES.TENANT"
              :url="URL.sys.tenant"
              :cache="false"
              filterable
              :show-custom-label-in-option="true"
              :custom-label="companyLabel"
              callback-method-type="value"
              @parentCallBack="filterTenantIdChangeHandler"
            />
          </el-form-item>
          <el-form-item label-width="0">
            <el-button no="1" type="primary" style="margin-left: 10px" @click="queryCompany()">{{ $t('CargoMsg.QueryCompany') }}</el-button>
            <el-button no="2" type="primary" style="margin-left: 10px" @click="showCopyDialog">{{ $t('CargoMsg.CopyCompany') }}</el-button>
          </el-form-item>
        </el-form>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="2024040203"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            style="width:100%;height:100%"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="2024040204"
            :total="searchConditions.total"
            :page.sync="searchConditions.pageNum"
            :limit.sync="searchConditions.pageSize"
            @pagination="queryCompany"
          />
        </div>
        <el-dialog
          v-el-drag-dialog
          :visible.sync="copyDialog.visible"
          :title="$t('CargoMsg.CopyCompany')"
          width="400px"
          :close-on-click-modal="false"
        >
          <el-form label-position="left">
            <el-form-item :label="$t('CargoMsg.CopyToCompany')" label-width="100px">
              <cargo-advance-select
                no="tenantId2"
                :select-type="TYPE_NAMES.TENANT"
                :cache="false"
                filterable
                :show-custom-label-in-option="true"
                :custom-label="companyLabel"
                :static-options="targetTenants"
                callback-method-type="value"
                @parentCallBack="p=>{copyDialog.tenantId=p}"
              />
            </el-form-item>
          </el-form>
          <div slot="footer">
            <el-button no="3" type="primary" @click="copyCompany">{{ $t('SeaExport.Confirm') }}</el-button>
            <el-button no="4" @click="closeDialog">{{ $t('CargoMsg.Cargo_Close') }}</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { copyCompanyToTenant, getAllCompanyList } from '@/api/batchMove'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import URL from '@/api/urlTranslator'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getAllTenant } from '@/api/auth'

export default {
  name: 'CompanyCopy',
  components: { CargoAdvanceSelect },
  data() {
    return {
      URL,
      searchConditions: {
        total: 0,
        pageNum: 100,
        pageSize: 0,
        tenantId: 0
      },
      copyDialog: {
        tenantId: 0,
        visible: false
      },
      targetTenants: [],
      tenants: [],
      companyUuidList: [],
      gridApi: null,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onRowDoubleClicked: () => {
          this.toLook()
        },
        onSortChanged: event => {
          if (this.selectedNode) {
            event.api.setFocusedCell(this.selectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: {
          componentParent: this
        }
      },
      rowData: []
    }
  },
  computed: {
    TYPE_NAMES() {
      return TYPE_NAMES
    },
    columnDefs() {
      return [
        {
          headerName: this.$t('baseInfo.partner.cmpIdx'),
          colId: 'cmpIdx',
          field: 'cmpIdx',
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true
          },
          checkboxSelection: true,
          width: 120,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          pinned: 'left'
        },
        {
          headerName: this.$t('baseInfo.partner.shortName'),
          field: 'shortName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChineseName'),
          field: 'chineseName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EnglishName'),
          field: 'englishName',
          width: 200
        },
        {
          headerName: this.$t('baseInfo.partner.cnShortName'),
          field: 'cnShortName',
          width: 100
        }, {
          headerName: this.$t('baseInfo.partner.branchId'),
          field: 'branchName',
          width: 200
        }, {
          headerName: this.$t('baseInfo.partner.isActive'),
          field: 'active',
          width: 100,
          cellRenderer: params => {
            return params.value ? this.$t('CargoMsg.Cargo_Yes') : this.$t('CargoMsg.Cargo_No')
          }
        }
      ]
    }
  },
  created() {
    getAllTenant().then(res => {
      this.tenants = res.data
    })
  },
  methods: {
    queryCompany() {
      if (!this.searchConditions.tenantId) {
        this.$message.warning(this.$t('BusinessIntelligence.businessIntelligence.saveWarning'))
        return
      }
      const loading = getLoading4Cxt(this)
      getAllCompanyList({
        tenantId: this.searchConditions.tenantId,
        pageNum: this.searchConditions.pageNum,
        pageSize: this.searchConditions.pageSize
      }).then(res => {
        this.rowData = res.data.list
        this.searchConditions.pageNum = res.data.pageNum
        this.searchConditions.pageSize = res.data.pageSize
        this.searchConditions.total = Number(res.data.total)
        this.gridApi.clearFocusedCell()
      }).catch(() => {

      }).finally(() => {
        loading.close()
      })
    },
    showCopyDialog() {
      this.copyDialog.visible = true
      this.targetTenants = this.tenants.filter(p => p.id !== this.searchConditions.tenantId)
    },
    copyCompany() {
      this.companyUuidList = []
      if (!this.copyDialog.tenantId) {
        this.$message.warning(this.$t('CargoMsg.PleaseSelectTargetTenant'))
        return
      }
      const rows = this.gridApi.getSelectedRows()
      if (!(rows.length > 0)) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      for (const row of rows) {
        this.companyUuidList.push(row.uuid)
      }
      const loading = getLoading4Cxt(this)
      copyCompanyToTenant({
        companyUuidList: this.companyUuidList,
        sourceTenantId: rows[0].tenantId,
        targetTenantId: this.copyDialog.tenantId
      }).then(res => {
        if (res.data) {
          this.$message.success(this.$t('CargoMsg.CopySuccessCount', [res.data]))
        }
      }).catch(() => {

      }).finally(() => {
        loading.close()
      })
      this.copyDialog.visible = false
    },
    closeDialog() {
      this.copyDialog.visible = false
    },
    companyLabel(data) {
      if (data) {
        return '[' + data.id + ']' + data.name
      }
      return ''
    },
    filterTenantIdChangeHandler(value) {
      this.searchConditions.tenantId = value
    }
  }
}
</script>
